import React, {useState} from 'react';
import PropTypes from 'prop-types';
import './index.scss';
import {FormattedMessage, injectIntl} from 'react-intl';
import cx from 'classnames';
import CloudinaryImage from '@stubhub/react-cloudinary';
import SellMarketingMessage from './messages';
import {getSliderImages} from './config';
import SlideController from './slide-controller';
import {Text} from '../../common/gutenberg';
import useInterval from './useInterval';

const INTERVAL = 12000;

const SellMarketing = ({intl}) => {
  const marketingContent = getSliderImages(intl);
  const enableCarousel = marketingContent.length > 1;
  const [currentActiveItemIndex, setCurrentActiveItemIndex] = useState(0);
  useInterval(() => changeActiveItem((currentActiveItemIndex + 1) % (marketingContent.length)), INTERVAL);

  const changeActiveItem = (index) => {
    if (enableCarousel) {
      setCurrentActiveItemIndex(index);
    }
  };

  return (
    <div className='SellMarketing__component'>
      <div className='SellMarketing__container'>
        {marketingContent.map(({name, title, content, alt, img}, index) =>
          (
            <div key={index}
              className={cx(`SellMarketing__slide SellMarketing__slide__${name}`, {
                'SellMarketing__showSlider' : index === currentActiveItemIndex,
                'SellMarketing__hideSlider': index !== currentActiveItemIndex
              })}>
              <div className='SellMarketing__content'>
                <Text component='div' className='SellMarketing__content__title Text--h3'>
                  <FormattedMessage {...SellMarketingMessage[title]} />
                </Text>
                <p className='SellMarketing__content__main'>
                  <FormattedMessage {...SellMarketingMessage[content]} />
                </p>
              </div>
              <figure className='SellMarketing__image'>
                <CloudinaryImage
                  className='SellMarketing__background__image'
                  alt={alt}
                  src={img}
                  enableCloudinary={true}
                  editZoomUrl={false}
                  useNamedTransforms={false} />
              </figure>
            </div>)
        )}
      </div>
      {enableCarousel && <SlideController
        elements={marketingContent}
        active={currentActiveItemIndex}
        onClick={changeActiveItem}
      />}
    </div>
  );
};

SellMarketing.propTypes = {
  intl: PropTypes.object.isRequired
};

export {SellMarketing};
export default injectIntl(SellMarketing);
